<template>
  <div class="overflow: auto">
    <div class="top" style=" font-size: 17px;">
      团队总人数：
      <div style="font-size:50px">{{slaveTotal}}</div>
      <Button
        type="primary"
        @click="modal1 = true"
        style="position: absolute;top: 38px;left: 200px; background: #2d8cf0;color: #FFF;font-size: 20px;padding: 0px 27px;"
      >团队增员</Button>
      <!-- @click="Add()" -->
      <Modal v-model="modal1" title="团队增员" @on-ok="Add">
        用户姓名：
        <Input v-model="username" placeholder="请输入用户姓名" style="width: auto;margin-right:15px" />用户手机号：
        <Input v-model="phone" placeholder="请输入用户手机号" style="width: auto" />
      </Modal>
    </div>

    <div class="query-c">
      查询：
      <Input
        v-model="keyword"
        @input="changeInput()"
        search
        placeholder="请输入姓名查询内容"
        style="width: auto"
      />
      <DatePicker
        type="daterange"
        split-panels
        placeholder="按时间查询"
        style="width: 200px;margin-left:20px"
        @on-change="queryTime"
      ></DatePicker>
    </div>
    <br />
    <Table style="font-size:20px" :content="self" border stripe :columns="columns1" :data="data1">
      <template slot-scope="{ row, index }" slot="action">
        <Button
          style="background: red;border-color: red;"
          v-if="row.state==1"
          type="error"
          size="small"
          @click="UserFrozen(row)"
        >封号</Button>
        <Button v-if="row.state==0" type="error" size="small" @click="UserFrozen(row)">解封</Button>
      </template>
    </Table>
    <br />
    <Page :total="total" @on-change="pagingSuery" show-elevator />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "TeamManagement",

  data() {
    return {
      modal1: false,
      total: 0,
      time: [],
      username: "",
      slaveTotal: "",
      phone: "",
      self: this,
      keyword: "",
      pageNow: 1,
      columns1: [
        {
          title: "姓名",
          align: "center",
          key: "username"
        },
        {
          title: "手机号",
          align: "center",
          key: "phone"
        },
        {
          title: "累计佣金（元）",
          align: "center",
          key: "rewardAmt"
        },
        {
          title: "加入日期",
          align: "center",
          key: "createTime"
        },
        {
          title: "状态",
          align: "center",
          key: "type"
        },
        {
          title: "管理",
          key: "address",
          align: "center",
          slot: "action"
        }
      ],
      data1: []
    };
  },

  activated: function() {
    this.getData("");
  },
  mounted: function() {
    this.getData("");
  },
  methods: {
    getData(keyword) {
      api
        .UserSlaves({
          keyword,
          pageNow: this.pageNow,
          pageSize: "10",
          startTime: this.time[0],
          endTime: this.time[1]
        })
        .then(res => {
          this.total = res.body.data.pageData.total;
          this.slaveTotal = res.body.data.slaveTotal;
          this.data1 = res.body.data.pageData.list;
          this.data1.forEach(element => {
            element.rewardAmt = element.rewardAmt / 100;
            if (element.state === 0) {
              element.type = "冻结";
            } else {
              element.type = "正常";
            }
          });
        });
    },
    UserFrozen(row) {
      api.UserFrozen(row.id).then(res => {
        this.$layer.alert(res.body.message);
        this.getData();
      });
    },
    changeInput() {
      this.getData(this.keyword);
    },
    queryTime(time) {
      this.time[0] = new Date(time[0]).valueOf();
      this.time[1] = new Date(time[1]).valueOf();
      this.getData(this.keyword);
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData(this.keyword);
    },
    Add() {
      if (!this.username) {
        this.$Message.info("姓名不能为空");
      } else if (!this.phone) {
        this.$Message.info("手机号不能为空");
      } else {
        api
          .UserAdd({
            username: this.username,
            phone: this.phone
          })
          .then(res => {
            this.$Message.info(res.body.message);
            this.getData("");
          });
      }
    }
  }
};
</script>

<style scoped>
.top {
  height: 90px;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #aaa;
  margin-bottom: 20px;
}
.ivu-btn-error {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
</style>